import { createReducer, on } from '@ngrx/store';
import { toggleSidebar } from './sidebar-actions.action';

export interface ISidebarActions {
  isOpened: boolean;
}
export const initialState: ISidebarActions = {
  isOpened: false,
};

export const getSidebarVisibility = (state: ISidebarActions) => state.isOpened;

export const sidebarActionsReducer = createReducer(
  initialState,
  on(toggleSidebar, (state, { isOpened }) => ({
    ...state,
    isOpened: isOpened,
  }))
);
